var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoThrive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 64 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-thrive") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-thrive",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "thrive",
    transform: "translate(5.000000, 14.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#193B70",
    points: "8.586 2.377 5.45 2.377 5.45 10.906 3.34 10.906 3.34 2.377 0.246 2.377 0.246 0.668 8.586 0.668"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#193B70",
    points: "18.122 10.907 16.013 10.907 16.013 6.518 11.9 6.518 11.9 10.907 9.789 10.907 9.789 0.668 11.9 0.668 11.9 4.816 16.013 4.816 16.013 0.668 18.122 0.668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.754,7.159 L22.074,7.159 L22.074,10.907 L19.963,10.907 L19.963,0.668 L23.766,0.668 C24.977,0.668 25.911,0.938 26.567,1.477 C27.223,2.016 27.551,2.778 27.551,3.762 C27.551,4.461 27.399,5.043 27.098,5.51 C26.793,5.975 26.336,6.346 25.721,6.623 L27.938,10.807 L27.938,10.907 L25.672,10.907 L23.754,7.159 Z M22.075,5.45 L23.774,5.45 C24.305,5.45 24.713,5.315 25.004,5.044 C25.295,4.776 25.442,4.405 25.442,3.931 C25.442,3.449 25.303,3.07 25.03,2.794 C24.757,2.517 24.335,2.378 23.766,2.378 L22.075,2.378 L22.075,5.45 L22.075,5.45 Z",
    id: "Shape",
    fill: "#193B70"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#193B70",
    points: "31.395 10.907 29.286 10.907 29.286 0.668 31.395 0.668"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#193B70",
    points: "37.133 8.368 39.455 0.669 41.803 0.669 38.241 10.907 36.038 10.907 32.485 0.669 34.829 0.669"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#193B70",
    points: "48.926 6.469 44.877 6.469 44.877 9.211 49.629 9.211 49.629 10.906 42.766 10.906 42.766 0.668 49.616 0.668 49.616 2.377 44.878 2.377 44.878 4.816 48.927 4.816 48.927 6.469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.838,9.907 C50.838,9.585 50.947,9.323 51.164,9.12 C51.383,8.919 51.656,8.819 51.984,8.819 C52.318,8.819 52.593,8.919 52.812,9.12 C53.031,9.323 53.138,9.585 53.138,9.907 C53.138,10.225 53.031,10.485 52.812,10.684 C52.597,10.885 52.322,10.983 51.984,10.983 C51.652,10.983 51.377,10.885 51.162,10.684 C50.948,10.485 50.838,10.225 50.838,9.907 Z",
    id: "Path",
    fill: "#F3967D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1352694,20.3862515 L39.6694336,9.46913053 L25.1113845,9.46913053 L25.1094965,4.88830889 C25.1094965,4.34898712 24.6875346,3.91304348 24.16551,3.91304348 L8.80434783,3.91304348 L8.80434783,25.7472855 L18.7394759,25.7472855 L18.7394759,31.3043478 L38.0987501,31.3043478 C38.8265637,31.3043478 39.2806212,30.540715 38.9134105,29.9350752 L33.1352694,20.3862515 Z",
    id: "Path",
    fill: "#F3967D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58474712,45 L1.28773029,45 C1.03687716,45 0.607633734,45 0,45 C0,44.3755012 0,43.9536382 0,43.7344108 L0,0 L5.86956399,0 L5.86956399,43.7334564 C5.86992076,43.9902084 5.86992076,44.4123896 5.86956399,45 C5.22604777,45 4.79777548,45 4.58474712,45 Z",
    id: "Path",
    fill: "#193B70"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoThrive);
export default __webpack_public_path__ + "static/media/logo-thrive.624b86727009873a02e250575e21dea9.svg";
export { ForwardRef as ReactComponent };